const DEFAULTS = {
    selector: '[data-toggle="lux-popup"]',
    param: "open",
    prefix: "lux-modal-",
    delayMs: 1200,
};

function normalizeWantedId(raw, prefix) {
    if (!raw) return null;
    return raw.startsWith(prefix) ? raw : `${prefix}${raw}`;
}

function readWantedId({ param, prefix }) {
    const url = new URL(location.href);
    const raw = url.searchParams.get(param) ?? location.hash.slice(1);
    return normalizeWantedId(raw, prefix);
}

function cleanupUrl(param) {
    const url = new URL(location.href);
    url.searchParams.delete(param);
    url.hash = "";
    history.replaceState(null, "", url);
}

function findTrigger(wantedId, selector) {
    return (
        document.querySelector(`${selector}[data-target="${wantedId}"]`) ||
        document.querySelector(`${selector}[data-target="#${wantedId}"]`) ||
        document.querySelector(`${selector}[href="#${wantedId}"]`)
    );
}

export function registerAutoOpenFromUrl(opts = {}) {
    const o = { ...DEFAULTS, ...opts };
    const wantedId = readWantedId(o);
    const trigger = findTrigger(wantedId, o.selector);

    if (!wantedId || !trigger) {
        cleanupUrl(o.param);

        return;
    }

    setTimeout(() => {
        trigger.dispatchEvent(
            new MouseEvent("click", { bubbles: true, cancelable: true }),
        );
    }, o.delayMs);
}
